import { useContext } from 'react';
import { ProfileContext } from '../modules/profile';
export default (function () {
  var _useContext = useContext(ProfileContext),
      profile = _useContext.profile,
      setProfile = _useContext.setProfile;

  return [profile, setProfile];
});